import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'

export function useIsHostingVersionUpdating() {
  return useSelector<RootState, boolean>(isHostingVersionUpdatingSelector)
}

export function isHostingVersionUpdatingSelector({ socketServer, app }: RootState): boolean {
  return !!socketServer.roomState?.isUpdating || !!app.present.updateHostingLoading
}
